import moment from 'moment';
import { useSelector } from 'react-redux';
import { DEFAULT_SECONDARY_COLOUR } from 'shared/constants/styleConstants';
import LastComponent from './common/lastComponent';

export default function TourSection({ componentProps }) {
  const { theme } = useSelector((state) => state.ui);
  const { componentName, componentData, componentFullName, isLastComponent } =
    componentProps;
  const component = componentData[componentFullName];

  return (
    <div className="flex mt-[30px] xs:mt-[40px] items-start relative">
      <svg
        width="50"
        height="50"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="relative z-10 hidden xs:inline"
      >
        <circle
          cx="25"
          cy="25"
          r="25"
          fill={theme.brandColour || DEFAULT_SECONDARY_COLOUR}
        />
        <path
          d="M26.9219 28.6365H18.0001V31.1819H26.9219V35.0001L32.0001 29.9092L26.9219 24.8183V28.6365Z"
          fill="white"
        />
        <path
          d="M23.0782 22.2728L32 22.2728L32 19.7274L23.0782 19.7274L23.0782 15.9092L18 21.0001L23.0782 26.091L23.0782 22.2728Z"
          fill="white"
        />
      </svg>

      <div className="xs:ml-[16px] mt-2">
        <div className="text-[22px] leading-[29.05px] font-medium flex xs:block items-center">
          <svg
            width="38"
            height="38"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="relative z-10 inline xs:hidden"
          >
            <circle
              cx="25"
              cy="25"
              r="25"
              fill={theme.primaryColour || DEFAULT_SECONDARY_COLOUR}
            />
            <path
              d="M26.9219 28.6365H18.0001V31.1819H26.9219V35.0001L32.0001 29.9092L26.9219 24.8183V28.6365Z"
              fill="white"
            />
            <path
              d="M23.0782 22.2728L32 22.2728L32 19.7274L23.0782 19.7274L23.0782 15.9092L18 21.0001L23.0782 26.091L23.0782 22.2728Z"
              fill="white"
            />
          </svg>
          <span className="ml-2.5 xs:ml-0">{componentName}</span>
        </div>
        <div className="max-w-[560px] text-[16px] leading-[31.2px] tracking-[0.25px] font-normal mt-[22px] flex">
          <div>
            <b>Tour:</b> {component.tourName || '-'}
            <br />
            <b>Starting:</b>{' '}
            {moment(Number(component.startDate)).format('DD MMMM yyyy')} at{' '}
            {moment(Number(component.startDate)).format('HH:mm')}
            <br />
            <b>Ending:</b>{' '}
            {moment(Number(component.endDate)).format('DD MMMM yyyy')} at{' '}
            {moment(Number(component.endDate)).format('HH:mm')}
          </div>
        </div>
      </div>

      {isLastComponent && <LastComponent />}
    </div>
  );
}
